// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__woOnM","content":"ManualTimeModal_content__2WJlD"};